<template>
  <div ref="containerRef">
    <slot v-if="isVisible" name="content" :isVisible="isVisible"></slot>
    <slot v-else name="placeholder" :isVisible="isVisible"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";

export default defineComponent({
  name: "LazyLoadingViewer",
  props: {
    rootMargin: { type: String, default: "200px" },
    threshold: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  emits: ["onVisible"],
  setup(props, { emit }) {
    const observer = ref<IntersectionObserver | null>(null);
    const containerRef = ref<HTMLElement | null>(null);
    const isVisible = ref(false);

    onMounted(() => {
      setupObserver();
    });

    onUnmounted(() => {
      disconnectObserver();
    });

    function disconnectObserver() {
      if (observer.value) {
        observer.value.disconnect();
      }
    }

    function setupObserver() {
      if (props.disabled) {
        isVisible.value = true;
        return;
      }
      disconnectObserver();
      const options = {
        root: null,
        rootMargin: props.rootMargin,
        threshold: props.threshold,
      };
      observer.value = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true;
            emit("onVisible");
            disconnectObserver();
          }
        });
      }, options);
      if (containerRef.value) {
        observer.value.observe(containerRef.value);
      }
    }

    return { isVisible, containerRef };
  },
});
</script>
